module.exports = __webpack_public_path__ + "static/img/u70055.4959bbae.png";